import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../ui/card';

const StatCard = ({ title, value }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-bold">{value}</p>
      </CardContent>
    </Card>
  );
};

export default StatCard;